var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesheetActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50033 4.5013V9.5013L12.8337 11.168M17.8337 9.5013C17.8337 14.1037 14.1027 17.8346 9.50033 17.8346C4.89795 17.8346 1.16699 14.1037 1.16699 9.5013C1.16699 4.89893 4.89795 1.16797 9.50033 1.16797C14.1027 1.16797 17.8337 4.89893 17.8337 9.5013Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetActive);
export default __webpack_public_path__ + "static/media/timesheet-active.7740decbe427c71b85c7ef10b0abd54f.svg";
export { ForwardRef as ReactComponent };